<div #instaStoryContainer class="story-model-container">
    <div class="closebtn">
        <span class="close theme-ex" [ngStyle]="{ color: closebtnClr }" (click)="closeModal()"></span>
    </div>
    <div
        class="story-move-up"
        id="instaStoryPageMatrixConatiner"
        (panleft)="onLeftSwipe()"
        (panright)="onRightSwipe()"
        (panup)="swipeToBottom()"
        (press)="pauseStory()"
        (pressup)="resumeStory()"
        (tap)="onTap($event)">
        <div class="matrix-page-container">
            <vn-page-matrix [path]="activeStoryPath" [product]="currentProduct"></vn-page-matrix>
        </div>
        <div class="progressbar-closebtn">
            <cc-instagram-story-progress-bar
                [activePromoIndex]="activePromoIndex"
                [activePromoStoryIndex]="activePromoStoryIndex"
                [storyData]="data.storyData"
                (sendStoryCompletionEvent)="storyCompletionEventFromProgressBar($event)">
            </cc-instagram-story-progress-bar>
        </div>
        <div class="btn-move-up">
            <span class="swipeuptxt" *ngIf="displaySwipeUp" [ngStyle]="{ color: swipeupTextColor }">{{ swipeupText }}</span>
            <span
                class="theme-arrow-left"
                *ngIf="displaySwipeUp"
                [ngStyle]="{ 'border-color': swipeupClr, 'color': swipeupClr }"
                (click)="swipeToBottom()"></span>
        </div>
    </div>
    <div #swipeupContentFrame class="story-move-down" (pandown)="swipeToTop()">
        <div class="story-move-down" *ngIf="displaySwipeUpContent">
            <div class="btn-move-down" [ngStyle]="{ 'background-color': promotionTitleBgClr, 'color': promotionTitleClr }">
                <span class="title-header">{{ Promotionpage_title }}</span>
                <span class="theme-down" *ngIf="displayDownArrow" (click)="swipeToTop()"></span>
            </div>
            <div class="matrix-page-container">
                <vn-page-matrix [path]="swipeUpStoryContentPath" [product]="currentProduct"></vn-page-matrix>
            </div>
        </div>
    </div>
</div>
